// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xFiltersOpenType = Readonly<{
    isOpen: boolean;
}>;

export const initialFiltersOpenState: xFiltersOpenType = {
    isOpen: true,
};


const reducer = {
    "xFiltersOpen/SetFiltersOpen": (draft: Draft<xFiltersOpenType>) => {
        draft.isOpen = !draft.isOpen;
    },
};

const xFiltersOpen = createTypedReducerWithImmer(initialFiltersOpenState, reducer);

(reducers as any).xFiltersOpen = xFiltersOpen;

export type xFiltersOpenState = {
    xFiltersOpen: xFiltersOpenType;
} & ApplicationState;

type xFiltersOpenReducers = {
    [key: string]: typeof xFiltersOpen;
};

export type xFiltersOpenActions = Parameters<xFiltersOpenReducers[keyof xFiltersOpenReducers]>[1] | AnyAction;
